<template>
  <div>
    <section v-if="!isLoading" id="register-form" class="mt-5">
      <div
        class="container d-flex justify-content-center align-items-center h-100"
      >
        <div
          class="card mb-3 shadow p-3 mb-5 bg-body rounded"
          style="width: 60rem"
        >
          <form action="" @submit.prevent="editPuskesmas(puskesmasId)">
            <div class="row g-0">
              <div class="col-md-12">
                <div class="card-body">
                  <h5 class="card-title text-center">Perbaharui Puskesmas</h5>
                  <div class="mb-3">
                    <label class="form-label">Nama Puskesmas</label>
                    <input
                      v-model="name"
                      type="text"
                      class="form-control"
                      id="email-form-login"
                      placeholder="Puskesmas Jajaway"
                    />
                  </div>
                  <div class="mb-3">
                    <label class="form-label">Alamat Puskesmas</label>
                    <input
                      v-model="address"
                      type="text"
                      class="form-control"
                      id="email-form-login"
                      placeholder="Bandung"
                    />
                  </div>
                  <div>
                    

                    <TesUpdate :passcoordinates="[longitude, latitude]" @updateLocation="setLocation"/>
                  </div>
                  <div class="mb-3">
                    <label class="form-label">Longitude</label>
                    <input
                      v-model="longitude"
                      
                      type="text"
                      class="form-control"
                      id="email-form-login"
                      placeholder="43432423"
                    />
                  </div>
                  <div class="mb-3">
                    <label class="form-label">Latitude</label>
                    <input
                      v-model="latitude"
                      
                      type="text"
                      class="form-control"
                      id="email-form-login"
                      placeholder="4234234"
                    />
                  </div>
                  <div class="mb-3">
                    <label class="form-label">Foto Puskesmas</label>
                    <input
                      @change="getPhoto"
                      class="form-control"
                      type="file"
                      placeholder="puskesmas.png"
                    />
                    <div class="d-flex justify-content-center">
                      <img
                        v-if="image"
                        :src="image"
                        style="width: 50%; height: 25%"
                        alt=""
                        class="d-flex justify-content-center"
                      />

                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="form-label">Kuota Harian</label>
                    <input
                      v-model="daily_quota"
                      type="number"
                      class="form-control"
                      id="email-form-login"
                      placeholder="20"
                    />
                  </div>

                  <div class="mb-3">
                    <label class="form-label">Pilih Vaksin</label>
                    <multiselect
                      v-model="vaccines"
                      tag-placeholder="Add this as new tag"
                      placeholder="Search or add a tag"
                      label="name"
                      track-by="id"
                      :options="getVaccines"
                      :multiple="true"
                      :taggable="true"
                      @tag="addTag"
                    ></multiselect>
                  </div>
                  <div class="d-flex w-100 my-3">
                    <input
                      class="btn btn-primary ml-2"
                      type="submit"
                      value="Update Puskesmas"
                    />
                    <button @click="cancel" class="btn btn-danger ml-3">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
    <loading v-if="isLoading"/>
  </div>
</template>

<script>
import Loading from './Loading.vue'
import TesUpdate from './TesUpdate.vue'
import baseURL from "../baseURL/baseUrl";
import axios from "axios";
import Multiselect from "vue-multiselect";
export default {
  name: "FormUpdatePuskesmas",
  data: function () {
    return {
      puskesmasId : '',
      name: "",
      address: "",
      longitude: "",
      latitude: "",
      imgUrl: "",
      daily_quota: "",
      vaccines: [],
      value: [],
      image : ''
    };
  },
  computed: {
    puskesmasDetail() {
      console.log("masuk di form update di computed");
      return this.$store.state.puskesmasDetail;
    },
    getVaccines() {
      return this.$store.state.vaccines;
    },
    isLoading(){
      return this.$store.state.loading
    }
  },
  components: {
    Multiselect,
    TesUpdate,
    Loading
  },
  methods: {
    editPuskesmas(id) {
      // console.log(this.imgUrl, );
      console.log('masuk update cek img');
      // console.log(this.name);
      // console.log(this.address);
      // console.log(this.longitude);
      // console.log(this.latitude);
      console.log(this.imgUrl, 'ini imageeeee');
      console.log(this.vaccines, 'ini vaccinesss');
      // console.log(this.daily_quota);
      // console.log(this.vaccines);
      this.$store.commit("SETLOADING", true);
      console.log(",asuk ,ethod update");
      var formData = new FormData();
      formData.append("name", this.name);
      formData.append("address", this.address);
      formData.append("longitude", this.longitude);
      formData.append("latitude", this.latitude);
      formData.append("daily_quota", this.daily_quota);
      formData.append("imgUrl", this.imgUrl);
      formData.append("vaccines", JSON.stringify(this.vaccines));

      this.$store.commit("UPDATEPUSKESMAS", {formData, id});
      this.$store
        .dispatch("updatePuskesmas")
        .then((response) => {
          console.log('masuk response');
          console.log(response);
           this.$vToastify.success({
            title : 'Sukses!',
            body: "Anda memperbaharui data puskesmas",
            theme : 'light'
          });
          this.$store.commit("SETLOADING", false);
          this.$router.push({ name: "ListPuskesmas" });

        })
        .catch((err) => {
          this.$store.commit("SETLOADING", false);
          this.$vToastify.error({
            title : 'Gagal!',
            body: err.response.data.errors[0],
            theme : 'light'
          });
          console.log(err.response);
        });
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        id: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.value.push(tag);
    },
    getPhoto(e) {
      console.log("masuk get photo");
      // console.log(e.target.files[0], 'ini target');
      // console.log(this.imgUrl, 'ini data awal');
        const file = e.target.files[0];
        // this.image = e.target.files[0]
        this.imgUrl = file
        this.image = URL.createObjectURL(file)
        // if(this.imgUrl == URL.createObjectURL(file)){
        //   this.image = URL.createObjectURL(file)
        // }else{
        //   this.image = file
        // }
        //   this.imgUrl = URL.createObjectURL(file);
    },
    setLocation(payload){
      console.log(payload, 'asup payload update');
      this.longitude = payload.longitude
      this.latitude = payload.latitude
    },
    cancel() {
      this.$router.push({ name: "ListPuskesmas" });
    },
  },
  // watch: {
  //   imgUrl: function (newValue, oldValue) {
  //     console.log({
  //       newValue: typeof newValue,
  //       oldValue,
  //     });
  //   },
  // },
  created() {
    let id = this.$route.params.id;
    console.log(id, "ini di form update");
    this.$store.commit("PUSKESMASID", id);
    axios({
      method: "GET",
      url: `${baseURL}/puskesmas/${id}`,
      headers: {
        access_token: localStorage.access_token,
      },
    })
      .then((response) => {
        let puskesmasDetail = response.data;
        console.log(puskesmasDetail);
        this.name = puskesmasDetail.name;
        this.address = puskesmasDetail.address;
        this.longitude = puskesmasDetail.longitude;
        this.latitude = puskesmasDetail.latitude;
        this.imgUrl = puskesmasDetail.imgUrl;
        this.image = puskesmasDetail.imgUrl
        this.daily_quota = puskesmasDetail.daily_quota;
        this.vaccines = puskesmasDetail.Vaccines;
        this.puskesmasId = puskesmasDetail.id
        
        
      })
      .catch((err) => {
        console.log(err);
      });
    this.$store.dispatch("fetchVaccines");
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
